'use client'

import { useContext } from 'react'

import { ClubMembershipContext } from '@/components/ClubMembershipProvider'
import { ClubMembershipStatus, resolveClubMembership } from '@/helpers/clubMembership'
import { useCustomer } from '@/store/customerStore'

// Re-export so block clients can keep importing the enum from this module.
export { ClubMembershipStatus }

/**
 * Client-side club membership status.
 *
 * Before the customer store hydrates, it trusts the server-seeded value (from
 * {@link ClubMembershipProvider}) so blocks render the correct UI + skeleton from
 * first paint — no Loading flash and no wrong-skeleton flash. With no provider it
 * falls back to Loading until hydration. After hydration the live store wins, so
 * a freshly granted Club:Member tag (or logout) is reflected immediately.
 */
export const useClubMembership = (): ClubMembershipStatus => {
  const seed = useContext(ClubMembershipContext)
  const customer = useCustomer(s => s.customer)
  const isLoaded = useCustomer(s => s.isLoaded)

  if (!isLoaded) return seed ?? ClubMembershipStatus.Loading

  return resolveClubMembership(customer)
}
